import { RepositOffersApi, RepositOfferWithRecipientDTO, RepositOfferRecipientDTOChoiceEnum } from '@reposit/api-client';
import { AxiosResponse } from 'axios';
import { getErrorMessage } from '../../utils/common.utils';
import { call, put, takeLatest } from 'redux-saga/effects';
import { syncEntitiesAndGetResults } from '../entities/entities.sagas';
import SCHEMA from '../schema';
import { createRepositOffersApi, runSagaWithAuth } from '../utils/api.utils';
import {
  fetchRepositOfferFailed,
  fetchRepositOfferSuccess,
  FETCH_REPOSIT_OFFER_API_REQUESTED,
  RepositOfferActionTypes,
  respondToRepositOfferSuccess,
  respondToRepositOfferFailed,
  RESPOND_TO_REPOSIT_OFFER_API_REQUESTED,
  ADD_REJECTION_REASON_API_REQUESTED,
} from './reposit-offer.actions';
import { FetchRepositOfferParams, RespondToRepositOfferParams, AddRejectionReasonParams } from './reposit-offer.types';
import { push } from 'connected-react-router';
import { HAS_CASH_DEPOSIT_ENABLED_QUERY, REPOSIT_PUBLISHED_QUERY } from '../../containers/RepositOffer/reposit-offer';

export function* fetchRepositOffer({ payload }: { type: string; payload: FetchRepositOfferParams }) {
  try {
    const api: RepositOffersApi = yield createRepositOffersApi();

    const { data }: AxiosResponse<RepositOfferWithRecipientDTO> = yield call(
      runSagaWithAuth(() => api.getRepositOffer(payload.repositOfferId, payload.token))
    );

    // adding id here because of the shape of the data
    yield syncEntitiesAndGetResults({ ...data, id: data.repositOffer.id }, SCHEMA.repositOffer);

    yield put<RepositOfferActionTypes>(fetchRepositOfferSuccess());
  } catch (e) {
    yield put<RepositOfferActionTypes>(fetchRepositOfferFailed(getErrorMessage(e)));
  }
}

export function* respondToRepositOffer({ payload }: { type: string; payload: RespondToRepositOfferParams }) {
  try {
    const api: RepositOffersApi = yield createRepositOffersApi();

    yield call(runSagaWithAuth(() => api.respondToOffer(payload.repositOfferId, payload.choice, payload.token)));

    yield put<RepositOfferActionTypes>(respondToRepositOfferSuccess());
    const route =
      payload.choice === RepositOfferRecipientDTOChoiceEnum.REPOSIT
        ? `/reposit-offer/${payload.repositOfferId}/accepted?${REPOSIT_PUBLISHED_QUERY}=${payload.repositPublished}`
        : `/reposit-offer/${payload.repositOfferId}/rejected?token=${payload.token}&${HAS_CASH_DEPOSIT_ENABLED_QUERY}=${payload.hasCashDepositEnabled}`;
    yield put(push(route));
  } catch (e) {
    yield put<RepositOfferActionTypes>(respondToRepositOfferFailed(getErrorMessage(e)));
  }
}

export function* addRejectionReason({ payload }: { type: string; payload: AddRejectionReasonParams }) {
  try {
    const { repositOfferId, rejectionReason, customRejectionReason, token } = payload;
    const api: RepositOffersApi = yield createRepositOffersApi();
    yield call(runSagaWithAuth(() => api.addRejectionReason(repositOfferId, { rejectionReason, customRejectionReason, token })));
    const route = `/reposit-offer/${repositOfferId}/reason-given`;
    yield put(push(route));
  } catch (e) {
    yield put<RepositOfferActionTypes>(respondToRepositOfferFailed(getErrorMessage(e)));
  }
}

//

// ****************
// WATCHERS
// ****************
export function* watchRepositOfferSagas() {
  yield takeLatest(FETCH_REPOSIT_OFFER_API_REQUESTED, fetchRepositOffer);
  yield takeLatest(RESPOND_TO_REPOSIT_OFFER_API_REQUESTED, respondToRepositOffer);
  yield takeLatest(ADD_REJECTION_REASON_API_REQUESTED, addRejectionReason);
}
